import axios from 'axios';
import config from 'config';
import { createApi } from 'utils/api';

const userV2Api = axios.create({
  baseURL: config.userV2ApiBaseUrl,
  params: {
    apikey: config.apiKey,
  },
});

const createUserV2Api = createApi(userV2Api);
export const getUserV2Data = createUserV2Api('get');
export const patchUserV2Data = createUserV2Api('patch');
export const postUserV2Data = createUserV2Api('post');
export const putUserV2Data = createUserV2Api('put');